/**
 * Formats a number with commas and two decimal places.
 * @param num - The number to format (e.g., 1000).
 * @returns The formatted number as a string (e.g., "1,000.00").
 */

const truncate = (num: number, decimals: number): number => {
  const factor = 10 ** decimals
  return Math.floor(num * factor) / factor
}

const addComma = (num: number | string): string => {
  if (!num) return '0.00'

  const parsedNum = parseFloat(num.toString())
  const formattedNum = truncate(parsedNum, 2).toFixed(2)

  return parsedNum > 999
    ? formattedNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : formattedNum
}

export default addComma
